import styled from 'styled-components';

export const HcpReportingWrapper = styled.div`
 display: flex;
`;
